import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import i18n from 'i18next';
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../../styles/styles';
import { renderTextField } from '../../../services/form';
import withTranslation from '../../../hoc/withTranslation';

const validate = values => {
    const errors = {};
    ['name'].forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });

    return errors;
};

export class PushGroupForm extends React.Component {

    static propTypes = {
        onFormReset: PropTypes.func,
        name: PropTypes.string
    };

    // Render

    render() {
        const {handleSubmit, pristine, reset, submitting, t} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={t("generic.name")}
                        fullWidth={true}
                    />
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.save")}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.reset")}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={() => {
                            reset();
                            if (this.props.onFormReset) {
                                this.props.onFormReset();
                            }
                        }}
                    />
                </div>
            </form>
        );
    }
}

PushGroupForm = reduxForm({
    form: 'addPushGroup',
    validate
})(PushGroupForm);

function mapStateToProps(state, ownProps) {
    let props = {...ownProps};

    if (ownProps.name) {
        if (ownProps.initialValues) {
            props.initialValues.name = ownProps.name
        } else {
            props.initialValues = {
                name: ownProps.name
            }
        }
    }

    return props;
}

export default connect(mapStateToProps, {})(withTranslation(PushGroupForm));




// WEBPACK FOOTER //
// src/components/push/PushGroupForm/PushGroupForm.js